var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable } from 'mobx';
import { runtime } from '../Runtime';
import { getPackagesNamesForSerialized } from '../../../packages/package_resolve';
export class RuntimePackages {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get runtime() {
        return this.parent;
    }
    get packageShelf() {
        return this.runtime.runtimeInjected && this.runtime.runtimeInjected.packageShelf;
    }
    makeAllPackagesAvailable() {
        this.packageShelf.packageNames.forEach((packageName) => {
            this.packageShelf[packageName].fetchPackage();
        });
    }
    getMissingPackagesNamesForSerialized(ser) {
        return getPackagesNamesForSerialized(ser).filter((n) => !runtime.runtimePackages.packageShelf[n].isAvailable);
    }
    async fetchMissingPackagesForSerialized(ser) {
        const missingPackageNames = this.getMissingPackagesNamesForSerialized(ser);
        await Promise.all(missingPackageNames.map((n) => runtime.runtimePackages.packageShelf[n].fetchPackage()));
        return;
    }
    canSerializedBeInstantiatedSynchronously(ser) {
        const missingPackageNames = this.getMissingPackagesNamesForSerialized(ser);
        const trigger = missingPackageNames.map((n) => runtime.runtimePackages.packageShelf[n].streamedPackage);
        return missingPackageNames.length === 0;
    }
}
__decorate([
    action.bound
], RuntimePackages.prototype, "makeAllPackagesAvailable", null);
